import { render, staticRenderFns } from "./UploadProfileBanner.vue?vue&type=template&id=558bec0a&"
import script from "./UploadProfileBanner.vue?vue&type=script&lang=js&"
export * from "./UploadProfileBanner.vue?vue&type=script&lang=js&"
import style0 from "./UploadProfileBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558bec0a')) {
      api.createRecord('558bec0a', component.options)
    } else {
      api.reload('558bec0a', component.options)
    }
    module.hot.accept("./UploadProfileBanner.vue?vue&type=template&id=558bec0a&", function () {
      api.rerender('558bec0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadProfileBanner.vue"
export default component.exports